dayjs.extend(window.dayjs_plugin_relativeTime);

class QRVerify extends HTMLElement {
  connectedCallback() {
    if (this.dataset.completed) return;
    this.dataset.completed = 'true';
    this.apiUrl = 'https://rpmpb-api.sideoutventures.com/authenticity';
    this.loadHistory();
  }

  async loadHistory() {
    const status = this.querySelector('[data-scan-history-status]');
    const list = this.querySelector('[data-scan-history-list]');
    const product = this.querySelector('[data-scan-history-product]');
    const productSpecs = document.querySelector('[data-pt-specs]');

    const count = document.querySelectorAll('[data-scan-history-count]');
    const valid = document.querySelectorAll('[data-qr-valid]');
    const invalid = document.querySelectorAll('[data-qr-invalid]');

    // get url variables
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');

    // id check
    if (!id || id === null) {
      valid.forEach((element) => element.hidden = true);
      invalid.forEach((element) => element.hidden = false);

      const loading = document.querySelectorAll('[data-loading]');
      const loaded = document.querySelectorAll('[data-loaded]');
      loading.forEach((element) => element.hidden = true);
      loaded.forEach((element) => element.hidden = false);

      this.hidden = true;
      this.showStatus(status, this.dataset.missingMessage);
      return;
    }

    // fetch
    try {
      const res = await fetch(`${this.apiUrl}/verify`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ token: id }),
      });
      if (!res.ok) throw new Error(`Request failed: ${res.status}`);

      const data = await res.json();
      const history = data?.scanHistory?.scans?.slice(0, 10);
      const totalScans = data?.scanHistory?.totalScans;
      const productData = data?.product;
      const tagData = data?.tag;

      this.renderHistory(list, history);
      this.renderProduct(productData, tagData, productSpecs);
      this.renderTag(tagData);
      count.forEach((i) => i.textContent = totalScans);
      
      if (totalScans) {
        this.showStatus(status, `Most Recent Scan: ${dayjs(history?.[0]?.scannedAt).fromNow()} in ${history?.[0]?.location?.city || 'N/A'}`);
      }
      this.hidden = false;
      valid.forEach((element) => element.hidden = false);
      invalid.forEach((element) => element.hidden = true);
    } catch (error) {
      this.hidden = true;
      this.showStatus(status, this.dataset.errorMessage);
      valid.forEach((element) => element.hidden = true);
      invalid.forEach((element) => element.hidden = false);
      console.error('Scan history request failed:', error);
    } finally {
      this.setAttribute('aria-busy', 'false');
      
      const loading = document.querySelectorAll('[data-loading]');
      const loaded = document.querySelectorAll('[data-loaded]');
      loading.forEach((element) => element.hidden = true);
      loaded.forEach((element) => element.hidden = false);
    }
  }

  showStatus(status, message) {
    status.textContent = message;
    status.hidden = false;
  }

  renderHistory(list, records) {
    list.innerHTML = records.map((i, index) => {
      return `
        <tr>
          <td>${dayjs(i.scannedAt).fromNow()}</td>
          <td>${i.maskedIp}</td>
          <td>
            <div class="city">
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin" data-loc="client/src/pages/Home.tsx:134"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </span>
              ${i.location.city}
            </div>
          </td>
        </tr>
      `;
    }).join('');
  }

  renderProduct(product, tag, list) {
    document.querySelector('[data-qr-pt-img]').innerHTML = `<img src="${product?.imageUrl || ''}" alt="" />`;
    document.querySelectorAll('[data-qr-pt-title]').forEach((i) => i.textContent = product?.title || 'N/A');
    document.querySelectorAll('[data-qr-pt-type]').forEach((i) => i.textContent = product?.productType || '');
    document.querySelectorAll('[data-qr-pt-tag]').forEach((i) => i.textContent = tag.itemId || 'N/A');
    document.querySelectorAll('[data-qr-pt-link]').forEach((i) => i.href = product?.productUrl);

    list.innerHTML = product?.specs?.map((i, index) => `
      <div>
        <span class="spec-label">${i.label}</span>
        <span class="spec-value">${i.value}</span>
      </div>
    `).join('');
  }

  renderTag(tag) {
    document.querySelector('[data-qr-tag]').innerHTML = `<img src="${tag?.imageUrl}" alt="" />`;
  }
}

if (!customElements.get('scan-history')) {
  customElements.define('scan-history', QRVerify);
}